/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Kanban_Open_Team_Project_ToastInputs */



/**
* | output |
* | --- |
* | "Opening team project via share code..." |
*
* @param {Explorer_Kanban_Open_Team_Project_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_open_team_project_toast = /** @type {((inputs?: Explorer_Kanban_Open_Team_Project_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_Open_Team_Project_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouverture du projet d'equipe via le code de partage...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eröffnung des Teamprojekts über ShareCode...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apertura del progetto di gruppo tramite codice di condivisione...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открытие командного проекта с помощью общего кода...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abriendo proyecto de equipo a través de código compartido...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("通过共享代码打开团队项目……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("共有コード経由でチーム プロジェクトを開いています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शेयर कोड के माध्यम से टीम प्रोजेक्ट शुरू करना...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abrindo projeto de equipe via código de compartilhamento...")
	return /** @type {LocalizedString} */ ("Opening team project via share code...")
});